<div class="icon mobile nf-pnf-logo" routerLink="/main/"></div>
<div class="area">
    <div class="titleImage notfound"></div>
    <div class="title">Sorry, Page Not Found :(</div>
    <div class="row center padTopBottom">
        <button *ngIf="!isCloudZiti" class="button" id="HomeButton" routerLink="/v7/dashboard">Take Me To The Dashboard</button>
        <button *ngIf="isCloudZiti" class="button" id="HomeButton" routerLink="/network/dashboard">Take Me To The Dashboard</button>
    </div>
    <app-copyright></app-copyright>
</div>
